export const getStep = state => state.wizard.step
export const getStepLoading = state => state.wizard.loading
